import { EMPTY_ARRAY_LENGTH } from "../../../../constants";
import { emptyString, brandProfileConstants } from "../../constants";

/**
 * Build SurveyCompletionDate (+ optional star) filter query used by
 * store / group / manager performance screens.
 */
export const buildSurveyCompletionDateFilterQuery = ({
  createDateFrom,
  createDateTo,
  starValue = [],
  or = brandProfileConstants.OR,
  and = brandProfileConstants.AND,
}) => {
  let query = `(SurveyCompletionDate > ${createDateFrom} and SurveyCompletionDate <= ${createDateTo})`;

  if (starValue.length > EMPTY_ARRAY_LENGTH) {
    const value = starValue.join(or);
    query = query.concat(" ", and, " ", `(${value})`);
  }

  return query;
};

/**
 * Shared createDate / id / type payload for performance pagination
 * and average-rating requests.
 */
export const buildDatedPerformanceRequestPayload = ({
  createDateFrom,
  createDateTo,
  id,
  type,
  requestBody = {},
}) => ({
  createDateFrom,
  createDateTo,
  id,
  type,
  ...requestBody,
});

/**
 * Map store-level performance export rows with calculated change fields.
 * Preserves other properties via spread.
 */
export const mapStoresPerformanceExportRecords = (items, calculateChange) =>
  items.map((item) => ({
    ...item,
    transactionChange: calculateChange(
      item.transactionRating,
      item.previousTransactionRating
    ),
    sentimentChange: calculateChange(
      item.sentimentRating,
      item.previousSentimentRating
    ),
  }));

/**
 * Build OR/AND filter query from a filter object (name/state/etc.).
 * Used by group/brand/manager profile screens.
 */
export const buildProfileFilterQuery = (filterObj, { or, and }) => {
  const filterNames = Object.keys(filterObj);
  const queryArray = filterNames.reduce((arr, name) => {
    const values = filterObj[name];
    if (values.length) {
      const filterValues = values.map((value) => `${name}="${value}"`);
      arr.push(`(${filterValues.join(or)})`);
    }
    return arr;
  }, []);

  return queryArray.length ? queryArray.join(and) : emptyString;
};

/**
 * Status card title when star filters are applied.
 */
export const getStarResponsesStatusTitle = (
  selectedOption,
  { allLabel, allResponsesLabel, buildFilteredLabel }
) => {
  const showAll =
    !selectedOption?.length ||
    selectedOption.some((item) => item.label === allLabel);

  if (showAll) {
    return allResponsesLabel;
  }

  return buildFilteredLabel(selectedOption);
};
